import BomSourceSerializer from 'eflex/serializers/bom-source';

export default class BarcodeBomSourceSerializer extends BomSourceSerializer {}
